import React, { useState, useEffect } from "react";
import api from "../../api/api";
import "../../css/Meeting.css";
import "../../css/Distributorveryfection.css";

const Distributorveryfection = () => {
  const [username, setUsername] = useState("");
  const [stateList, setStateList] = useState([]);

  const [inputData, setInputData] = useState({
    name: "",
    firm_name: "",
    email: "",
    state: "",
    district: "",
    tehsil: "",
    village: "",
    phone: "",
    tax_number: "",
    adresse: "",
  });

  const [documents, setDocuments] = useState([
    { name: "", number: "", images: [] },
  ]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };

  const handleAddDocument = () => {
    if (documents.length < 4) {
      setDocuments([...documents, { name: "", number: "", images: [] }]);
    }
  };

  const handleRemoveDocument = (index) => {
    if (documents.length === 1) {
      return;
    }
    const updatedDocs = documents.filter((_, i) => i !== index);
    setDocuments(updatedDocs);
  };

  const handleDocumentChange = (index, field, value) => {
    const updatedDocs = [...documents];
    updatedDocs[index][field] = value;
    setDocuments(updatedDocs);
  };

  const handleImageChange = (e, docIndex) => {
    const files = Array.from(e.target.files);
    const updatedDocs = [...documents];

    if (!updatedDocs[docIndex].images) {
      updatedDocs[docIndex].images = [];
    }

    updatedDocs[docIndex].images.push(...files);
    setDocuments(updatedDocs);
  };

  const handleImageDelete = (docIndex, imgIndex) => {
    const updatedDocs = [...documents];
    updatedDocs[docIndex].images.splice(imgIndex, 1);
    setDocuments(updatedDocs);
  };

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await api.get("/employee-profile");
        if (res.data.success && res.data.data) {
          setUsername(res.data.data.username || "No Name");
        } else {
          console.error("Failed to fetch employee profile");
        }
      } catch (err) {
        console.error("Error fetching profile");
      }
    };

    const fetchStates = async () => {
      try {
        const res = await api.get("/get/state");
        if (res.data.success && res.data.data) {
          setStateList(
            res.data.data.map((state) => ({
              id: state.state_id,
              name: state.state_title,
            }))
          );
        } else {
          console.error("Failed to fetch states");
        }
      } catch (err) {
        console.error("Error fetching states");
      }
    };

    fetchProfile();
    fetchStates();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Step-by-step validation for inputData fields
    if (!inputData.name) {
      alert("Please enter name.");
      return;
    }

    if (!inputData.firm_name) {
      alert("Please enter Firm Name.");
      return;
    }

    if (!inputData.email) {
      alert("Please enter email.");
      return;
    }
    if (!inputData.state) {
      alert("Please select a state.");
      return;
    }
    if (!inputData.district) {
      alert("Please select a district.");
      return;
    }
    if (!inputData.tehsil) {
      alert("Please enter tehsil.");
      return;
    }
    if (!inputData.village) {
      alert("Please enter village.");
      return;
    }
    if (!inputData.phone) {
      alert("Please enter phone number.");
      return;
    }
    if (!inputData.tax_number) {
      alert("Please enter tax number.");
      return;
    }
    if (!inputData.adresse) {
      alert("Please enter address.");
      return;
    }

    // ✅ Validation for documents
    for (let i = 0; i < documents.length; i++) {
      const doc = documents[i];
      const index = i + 1;

      if (!doc.name) {
        alert(`Please enter name for document ${index}.`);
        return;
      }
      if (!doc.number) {
        alert(`Please enter number for document ${index}.`);
        return;
      }
      if (!doc.images || doc.images.length === 0) {
        alert(`Please upload at least one image for document ${index}.`);
        return;
      }
    }

    const formData = new FormData();

    Object.entries(inputData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    documents.forEach((doc, index) => {
      const docIndex = index + 1;
      if (doc.name) formData.append(`document${docIndex}_type`, doc.name);
      if (doc.number) formData.append(`document${docIndex}_number`, doc.number);
      if (doc.images && doc.images.length > 0) {
        doc.images.forEach((imageFile) => {
          formData.append(`document${docIndex}_image[]`, imageFile);
        });
      }
    });

    try {
      const response = await api.post("/add/distributor", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.success) {
        alert("Distributor registered successfully!");

        // 🔁 Reset input fields and documents after successful submit
        setInputData({
          name: "",
          firm_name: "",
          email: "",
          state: "",
          district: "",
          tehsil: "",
          village: "",
          phone: "",
          tax_number: "",
          adresse: "",
        });
        setDocuments([{ name: "", number: "", images: [] }]);
      } else {
        alert("Failed to register distributor: " + response.data.message);
      }
    } catch (error) {
      alert("Error submitting form: " + error.message);
    }
  };

  return (
    <section className="meeting-section distributor-section">
      <div className="container">
        <div className="inner-content">
          <div className="left-wrapper">
            <div className="bottom-bar">
              <h2>Distributor Verification</h2>
              <div className="form">
                <form onSubmit={handleSubmit}>
                  <div className="row-wrapper">
                    <div className="main-wrapper">
                      <label>Name</label>
                      <input
                        type="text"
                        name="name"
                        placeholder="Name"
                        value={inputData.name}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="main-wrapper">
                      <label>Firm Name</label>
                      <input
                        type="text"
                        name="firm_name"
                        placeholder="Firm Name"
                        value={inputData.firm_name}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="main-wrapper">
                      <label>Email</label>
                      <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={inputData.email}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="main-wrapper">
                      <label>Phone Number</label>
                      <input
                        type="number"
                        name="phone"
                        placeholder="Phone Number"
                        value={inputData.phone}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="main-wrapper">
                      <label>GST Number</label>
                      <input
                        type="text"
                        name="tax_number"
                        placeholder="GST Number"
                        value={inputData.tax_number}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="main-wrapper">
                      <label>Address</label>
                      <input
                        type="text"
                        name="adresse"
                        placeholder="Address"
                        value={inputData.adresse}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="main-wrapper">
                      <label>State</label>
                      <select
                        name="state"
                        value={inputData.state}
                        onChange={handleInputChange}
                      >
                        <option value="">Select State</option>
                        {stateList.map((state) => (
                          <option key={state.id} value={state.name}>
                            {state.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="main-wrapper">
                      <label>District</label>
                      <input
                        type="text"
                        name="district"
                        placeholder="District"
                        value={inputData.district}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="main-wrapper">
                      <label>Tehsil</label>
                      <input
                        type="text"
                        name="tehsil"
                        placeholder="Tehsil"
                        value={inputData.tehsil}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="main-wrapper">
                      <label>Village</label>
                      <input
                        type="text"
                        name="village"
                        placeholder="Village"
                        value={inputData.village}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="main-uplode-001">
                    {documents.map((doc, index) => (
                      <div className="bottom-form" key={index}>
                        <div className="document-001">
                          <div className="main-document">
                            <input
                              type="text"
                              placeholder="Document Name"
                              value={doc.name}
                              onChange={(e) =>
                                handleDocumentChange(
                                  index,
                                  "name",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                          <div className="main-document">
                            <input
                              type="text"
                              placeholder="Document No."
                              value={doc.number}
                              onChange={(e) =>
                                handleDocumentChange(
                                  index,
                                  "number",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        </div>

                        <div className="select-multipal-image">
                          <label
                            htmlFor={`fileUpload-${index}`}
                            className="image-upload-label"
                          >
                            <img
                              src="/images/icon-image.png"
                              alt="Choose"
                              className="upload-icon"
                            />
                          </label>
                          <input
                            type="file"
                            id={`fileUpload-${index}`}
                            accept="image/*"
                            multiple
                            onChange={(e) => handleImageChange(e, index)}
                            style={{ display: "none" }}
                          />

                          <div className="image-preview-container">
                            {doc.images.map((img, imgIndex) => (
                              <div className="preview-wrapper" key={imgIndex}>
                                <img
                                  src={URL.createObjectURL(img)}
                                  alt={`Preview ${imgIndex}`}
                                  className="preview-image"
                                />
                                <button
                                  type="button"
                                  className="delete-image-btn"
                                  onClick={() =>
                                    handleImageDelete(index, imgIndex)
                                  }
                                >
                                  <i className="fa-solid fa-xmark"></i>
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>

                        <div style={{ marginTop: "10px" }}>
                          <button
                            type="button"
                            onClick={() => handleRemoveDocument(index)}
                            className="delete-button"
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    ))}

                    <div className="multipal-add-button">
                      <button type="button" onClick={handleAddDocument}>
                        Add &nbsp;<i className="fa-solid fa-plus"></i>
                      </button>
                    </div>
                  </div>

                  <div className="btn-sub">
                    <button type="submit">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Distributorveryfection;
